import Vue from 'vue';
import directive from './directive';

export default {
    install: () => {
        Vue.directive('mask', directive);
    }
};